<div class="loading" *ngIf="loading">
  <div class="spinner-border" role="status"></div>
</div>

<div class="component-editor editor-shell" *ngIf="!loading">
  <div class="editor-header">
    <div>
      <h3 class="editor-title">{{ 'NEW_MENU' | translate }}</h3>
    </div>
  </div>

  <!-- Stepper Nav -->
  <div class="stepper">
    <div class="stepper-progress">
      <div class="stepper-progress-bar" [style.width.%]="stepProgress"></div>
    </div>
    <div class="stepper-nav-menu">
      <div *ngFor="let step of steps; trackBy: trackByIndex"
           class="stepper-chip"
           [class.is-active]="isCurrentStep(step.index)"
           [class.is-complete]="isStepComplete(step.index)"
           (click)="goToStep(step.index)"
           style="cursor: pointer;">
        <span class="stepper-index">{{ step.index }}</span>
        <div>
          <div class="stepper-label">{{ step.label | translate }}</div>
          <small>{{ step.description | translate }}</small>
        </div>
      </div>
    </div>
  </div>

  <div class="step-actions"
       style="background: rgba(255, 248, 243, 0.96); border: 1px solid #efdfd3; border-radius: 18px; margin-top: -0.25rem; padding: 0.9rem 1rem; position: sticky; top: 0.75rem; z-index: 10;">
    <div class="step-card-copy" style="margin: 0;">
      {{ steps[currentStep - 1].label | translate }}
    </div>
    <button type="button" class="btn btn-step btn-primary" (click)="saveMenu()">
      {{ 'CREATE' | translate }}
    </button>
  </div>

  <!-- ═══ Step 1: Options Summary Cards ═══ -->
  <section class="step-card" *ngIf="currentStep === 1">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'MENU_STEP_2_TITLE' | translate }}</h4>
        <p class="step-card-copy">{{ 'MENU_STEP_2_DESC' | translate }}</p>
      </div>
      <button type="button" class="add-item-btn add-item-btn--option" (click)="addMenuOption(); editOption(menuOptions.length - 1)">
        <span class="add-item-btn__icon">+</span>
        <span>{{ 'ADD_OPTION' | translate }}</span>
      </button>
    </div>

    <div class="empty-state" *ngIf="menuOptions.length === 0">
      <p>{{ 'NO_OPTIONS_YET' | translate }}</p>
    </div>

    <div class="option-cards" *ngIf="menuOptions.length > 0">
      <div *ngFor="let opt of menuOptions; let i = index; trackBy: trackByIndex" class="option-card">
        <div class="option-card__toolbar">
          <span class="option-card__position">{{ i + 1 }}</span>
          <div class="option-card__icon-actions">
            <button type="button" class="edit-btn" (click)="editOption(i)" [title]="'EDIT_OPTION' | translate">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"/></svg>
            </button>
            <button type="button" class="delete-btn" (click)="removeMenuOption(i)" [title]="'DELETE' | translate">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="currentColor" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6z"/></svg>
            </button>
          </div>
        </div>

        <div class="option-card__body">
          <strong class="option-card__name">{{ opt.optionName || ('NO_NAME' | translate) }}</strong>
          <span class="option-card__badge" *ngIf="opt.optionType">{{ getOptionTypeLabel(opt.optionType) | translate }}</span>
          <button type="button" class="suboptions-btn" (click)="viewSuboptions(i)">
            {{ 'VIEW_N_SUBOPTIONS' | translate:{ count: opt.children?.length || 0 } }}
          </button>
        </div>
      </div>
    </div>

    <div class="step-actions">
      <div></div>
    </div>
  </section>

  <!-- ═══ Step 2: Edit Single Option ═══ -->
  <section class="step-card" *ngIf="currentStep === 2 && selectedOption">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'MENU_STEP_3_TITLE' | translate }}</h4>
        <p class="step-card-copy">{{ 'MENU_STEP_3_DESC' | translate }}</p>
      </div>
      <a class="back-link" (click)="backToOptions()">{{ 'BACK_TO_OPTIONS' | translate }}</a>
    </div>

    <div class="section-grid">
      <div class="section-block">
        <label class="section-label">{{ 'OPTION_NAME' | translate }}</label>
        <input type="text" class="form-control"
               [(ngModel)]="selectedOption.optionName"
               [placeholder]="'OPTION_NAME' | translate"
               name="editOptionName" required />
      </div>
      <div class="section-block"></div>
    </div>

    <div class="section-block mt-3">
      <label class="section-label mb-2">{{ 'TYPE' | translate }}</label>
      <div class="radios-container">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="categories"
                 [checked]="isOptionType(selectedOption.optionType, 'categories')"
                 (change)="onOptionChange('categories', selectedOptionIndex)">
          <label class="form-check-label">{{ 'CATEGORY' | translate }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="subCategories"
                 [checked]="isOptionType(selectedOption.optionType, 'subCategories')"
                 (change)="onOptionChange('subCategories', selectedOptionIndex)">
          <label class="form-check-label">{{ 'SUBCATEGORY' | translate }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="subSubcategories"
                 [checked]="isOptionType(selectedOption.optionType, 'subSubcategories')"
                 (change)="onOptionChange('subSubcategories', selectedOptionIndex)">
          <label class="form-check-label">{{ 'SUB_SUBCATEGORIES' | translate }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="collections"
                 [checked]="isOptionType(selectedOption.optionType, 'collections')"
                 (change)="onOptionChange('collections', selectedOptionIndex)">
          <label class="form-check-label">{{ 'COLLECTIONS' | translate }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="pages"
                 [checked]="isOptionType(selectedOption.optionType, 'pages')"
                 (change)="onOptionChange('pages', selectedOptionIndex)">
          <label class="form-check-label">{{ 'PAGES' | translate }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="optionTypeRadio" value="custom"
                 [checked]="isOptionType(selectedOption.optionType, 'custom')"
                 (change)="onOptionChange('custom', selectedOptionIndex)">
          <label class="form-check-label">{{ 'EXTERNAL_LINK' | translate }}</label>
        </div>
      </div>
    </div>

    <div class="section-block mt-3" *ngIf="selectedOption.optionType">
      <div *ngIf="isOptionType(selectedOption.optionType, 'categories')" class="form-floating col-md-5">
        <select class="form-select" (change)="onCategoryChange($event, selectedOptionIndex)">
          <option disabled [selected]="!selectedOption.categoryId">{{ 'SELECT_CATEGORY' | translate }}</option>
          <option *ngFor="let cat of categories" [value]="cat.categoryId"
                  [selected]="selectedOption.categoryId === cat.categoryId">{{ cat.categoryName }}</option>
        </select>
      </div>
      <div *ngIf="isOptionType(selectedOption.optionType, 'subCategories')" class="form-floating col-md-5">
        <select class="form-select" (change)="onSubCategoryChange($event, selectedOptionIndex)">
          <option disabled [selected]="!selectedOption.subCategoryId">{{ 'SELECT_SUBCATEGORY' | translate }}</option>
          <option *ngFor="let sub of subCategories" [value]="sub.subCategoryId"
                  [selected]="selectedOption.subCategoryId === sub.subCategoryId">{{ sub.subCategoryName }}</option>
        </select>
      </div>
      <div *ngIf="isOptionType(selectedOption.optionType, 'subSubcategories')" class="form-floating col-md-5">
        <select class="form-select" (change)="onSubSubCategoryChange($event, selectedOptionIndex)">
          <option disabled [selected]="!selectedOption.subSubCategoryId">{{ 'SELECT_SUB_SUBCATEGORY' | translate }}</option>
          <option *ngFor="let sub of subSubCategories" [value]="sub.subSubCategoryId"
                  [selected]="selectedOption.subSubCategoryId === sub.subSubCategoryId">{{ sub.subSubCategoryName }}</option>
        </select>
      </div>
      <div *ngIf="isOptionType(selectedOption.optionType, 'collections')" class="form-floating col-md-5">
        <select class="form-select" (change)="onCollectionChange($event, selectedOptionIndex)">
          <option disabled [selected]="!selectedOption.collectionId">{{ 'SELECT_COLLECTION' | translate }}</option>
          <option *ngFor="let col of collections" [value]="col.collectionId"
                  [selected]="selectedOption.collectionId === col.collectionId">{{ col.collectionName }}</option>
        </select>
      </div>
      <div *ngIf="isOptionType(selectedOption.optionType, 'custom')" class="form-floating col-md-5">
        <input type="text" class="form-control"
               [ngClass]="{'is-invalid': selectedOption.optionUrl && !isValidHttpUrl(selectedOption.optionUrl)}"
               [(ngModel)]="selectedOption.optionUrl"
               [placeholder]="'OPTION_URL' | translate"
               name="editOptionUrl" required>
        <label>{{ 'OPTION_URL' | translate }}</label>
        <div class="invalid-feedback" *ngIf="selectedOption.optionUrl && !isValidHttpUrl(selectedOption.optionUrl)">
          {{ 'INVALID_URL_FORMAT' | translate }}
        </div>
      </div>
      <div *ngIf="isOptionType(selectedOption.optionType, 'pages')" class="form-floating col-md-5">
        <select class="form-select" (change)="onPageChange($event, selectedOptionIndex)">
          <option disabled [selected]="!selectedOption.pageId">{{ 'SELECT_PAGE' | translate }}</option>
          <option *ngFor="let page of pages" [value]="page.pageId"
                  [selected]="selectedOption.pageId === page.pageId">{{ page.pageName }}</option>
        </select>
      </div>
    </div>

    <div class="step-actions">
      <button type="button" class="btn btn-step btn-secondary" (click)="backToOptions()">{{ 'BACK_TO_OPTIONS' | translate }}</button>
      <button type="button" class="btn btn-step btn-secondary" (click)="viewSuboptions(selectedOptionIndex)">{{ 'VIEW_SUBOPTIONS' | translate }}</button>
      <!-- <button type="button" class="btn btn-step btn-primary" (click)="saveAndBackFromOption()">Save & Back</button> -->
    </div>
  </section>

  <!-- ═══ Step 3: Suboptions ═══ -->
  <section class="step-card" *ngIf="currentStep === 3 && selectedOption">
    <div class="step-card-header">
      <div>
        <h4 class="step-card-title">{{ 'MENU_STEP_4_TITLE' | translate }}</h4>
        <p class="step-card-copy">{{ 'MENU_STEP_4_DESC' | translate }} — {{ selectedOption.optionName || ('NO_NAME' | translate) }}</p>
      </div>
      <a class="back-link" (click)="backToOption()">{{ 'BACK_TO_OPTION' | translate }}</a>
    </div>

    <div class="mb-3 d-flex justify-content-end">
      <button type="button" class="add-item-btn add-item-btn--suboption" (click)="addSubMenuOption(selectedOptionIndex); editSubOption(selectedOption.children.length - 1)">
        <span class="add-item-btn__icon">+</span>
        <span>{{ 'ADD_SUBOPTION' | translate }}</span>
      </button>
    </div>

    <div class="empty-state" *ngIf="!selectedOption.children?.length">
      <p>{{ 'NO_SUBOPTIONS_YET' | translate }}</p>
    </div>

    <div class="suboption-chips" *ngIf="selectedOption.children?.length">
      <div *ngFor="let child of selectedOption.children; let j = index; trackBy: trackByIndex"
           class="suboption-chip"
           [class.is-active]="activeSubOptionIndex === j"
           (click)="editSubOption(j)">
        <span class="suboption-chip__index">{{ j + 1 }}</span>
        <span>{{ child.optionName || ('NO_NAME' | translate) }}</span>
        <span class="suboption-chip__badge" *ngIf="child.optionType">{{ getOptionTypeLabel(child.optionType) | translate }}</span>
        <button type="button" class="suboption-chip__remove" (click)="removeSubMenuOption(selectedOptionIndex, j); $event.stopPropagation()">×</button>
      </div>
    </div>

    <div class="suboption-edit-panel" *ngIf="activeSubOption">
      <h6>{{ 'SUBOPTION' | translate }} {{ activeSubOptionIndex + 1 }}</h6>
      <div class="section-grid">
        <div class="section-block">
          <label class="section-label">{{ 'SUBOPTION_NAME' | translate }}</label>
          <input type="text" class="form-control"
                 [(ngModel)]="activeSubOption.optionName"
                 [placeholder]="'SUBOPTION_NAME' | translate"
                 name="subOptName" required />
        </div>
        <div class="section-block"></div>
      </div>

      <div class="section-block mt-3">
        <label class="section-label mb-2">{{ 'TYPE' | translate }}</label>
        <div class="radios-container">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="categories"
                   [checked]="isOptionType(activeSubOption.optionType, 'categories')"
                   (change)="onSubOptionTypeChange('categories')">
            <label class="form-check-label">{{ 'CATEGORY' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="subCategories"
                   [checked]="isOptionType(activeSubOption.optionType, 'subCategories')"
                   (change)="onSubOptionTypeChange('subCategories')">
            <label class="form-check-label">{{ 'SUBCATEGORY' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="subSubcategories"
                   [checked]="isOptionType(activeSubOption.optionType, 'subSubcategories')"
                   (change)="onSubOptionTypeChange('subSubcategories')">
            <label class="form-check-label">{{ 'SUB_SUBCATEGORIES' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="collections"
                   [checked]="isOptionType(activeSubOption.optionType, 'collections')"
                   (change)="onSubOptionTypeChange('collections')">
            <label class="form-check-label">{{ 'COLLECTIONS' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="pages"
                   [checked]="isOptionType(activeSubOption.optionType, 'pages')"
                   (change)="onSubOptionTypeChange('pages')">
            <label class="form-check-label">{{ 'PAGES' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="subOptionTypeRadio" value="custom"
                   [checked]="isOptionType(activeSubOption.optionType, 'custom')"
                   (change)="onSubOptionTypeChange('custom')">
            <label class="form-check-label">{{ 'EXTERNAL_LINK' | translate }}</label>
          </div>
        </div>
      </div>

      <div class="section-block mt-3" *ngIf="activeSubOption.optionType">
        <div *ngIf="isOptionType(activeSubOption.optionType, 'categories')" class="form-floating col-md-5">
          <select class="form-select" (change)="applySelectValue(activeSubOption, 'categoryId', $event)">
            <option disabled [selected]="!activeSubOption.categoryId">{{ 'SELECT_CATEGORY' | translate }}</option>
            <option *ngFor="let cat of categories" [value]="cat.categoryId"
                    [selected]="activeSubOption.categoryId == cat.categoryId">{{ cat.categoryName }}</option>
          </select>
        </div>
        <div *ngIf="isOptionType(activeSubOption.optionType, 'subCategories')" class="form-floating col-md-5">
          <select class="form-select" (change)="applySelectValue(activeSubOption, 'subCategoryId', $event)">
            <option disabled [selected]="!activeSubOption.subCategoryId">{{ 'SELECT_SUBCATEGORY' | translate }}</option>
            <option *ngFor="let sub of subCategories" [value]="sub.subCategoryId"
                    [selected]="activeSubOption.subCategoryId == sub.subCategoryId">{{ sub.subCategoryName }}</option>
          </select>
        </div>
        <div *ngIf="isOptionType(activeSubOption.optionType, 'subSubcategories')" class="form-floating col-md-5">
          <select class="form-select" (change)="applySelectValue(activeSubOption, 'subSubCategoryId', $event)">
            <option disabled [selected]="!activeSubOption.subSubCategoryId">{{ 'SELECT_SUB_SUBCATEGORY' | translate }}</option>
            <option *ngFor="let sub of subSubCategories" [value]="sub.subSubCategoryId"
                    [selected]="activeSubOption.subSubCategoryId == sub.subSubCategoryId">{{ sub.subSubCategoryName }}</option>
          </select>
        </div>
        <div *ngIf="isOptionType(activeSubOption.optionType, 'collections')" class="form-floating col-md-5">
          <select class="form-select" (change)="applySelectValue(activeSubOption, 'collectionId', $event)">
            <option disabled [selected]="!activeSubOption.collectionId">{{ 'SELECT_COLLECTION' | translate }}</option>
            <option *ngFor="let col of collections" [value]="col.collectionId"
                    [selected]="activeSubOption.collectionId == col.collectionId">{{ col.collectionName }}</option>
          </select>
        </div>
        <div *ngIf="isOptionType(activeSubOption.optionType, 'custom')" class="form-floating col-md-5">
          <input type="text" class="form-control"
                 [ngClass]="{'is-invalid': activeSubOption.optionUrl && !isValidHttpUrl(activeSubOption.optionUrl)}"
                 [(ngModel)]="activeSubOption.optionUrl"
                 [placeholder]="'OPTION_URL' | translate"
                 name="subOptUrl">
          <label>{{ 'OPTION_URL' | translate }}</label>
          <div class="invalid-feedback" *ngIf="activeSubOption.optionUrl && !isValidHttpUrl(activeSubOption.optionUrl)">
            {{ 'INVALID_URL_FORMAT' | translate }}
          </div>
        </div>
        <div *ngIf="isOptionType(activeSubOption.optionType, 'pages')" class="form-floating col-md-5">
          <select class="form-select" (change)="applySelectValue(activeSubOption, 'pageId', $event)">
            <option disabled [selected]="!activeSubOption.pageId">{{ 'SELECT_PAGE' | translate }}</option>
            <option *ngFor="let p of pages" [value]="p.pageId"
                    [selected]="activeSubOption.pageId == p.pageId">{{ p.pageName }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="step-actions">
      <button type="button" class="btn btn-step btn-secondary" (click)="backToOption()">{{ 'BACK_TO_OPTION' | translate }}</button>
      <button type="button" class="btn btn-step btn-secondary" (click)="backToOptions()">{{ 'BACK_TO_OPTIONS' | translate }}</button>
    </div>
  </section>
</div>

<div class="modal menu-confirm-modal fade" id="successMenuModal" tabindex="-1">
  <div class="modal-dialog menu-modal-dialog" role="document">
    <div class="modal-content menu-modal-content">
      <div class="modal-body menu-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{ 'MENU_CREATED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal menu-confirm-modal fade" id="errorMenuModal" tabindex="-1">
  <div class="modal-dialog menu-modal-dialog" role="document">
    <div class="modal-content menu-modal-content">
      <div class="modal-body menu-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal menu-confirm-modal fade" id="requiredMenuModal" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{ 'ALL_FIELDS_REQUIRED' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal menu-confirm-modal fade" id="errorCreateMenuUrl" tabindex="-1">
    <div class="modal-dialog menu-modal-dialog" role="document">
      <div class="modal-content menu-modal-content">
        <div class="modal-body menu-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{ 'INVALID_URL' | translate }} {{ itemListId }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{ 'CLOSE' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
  
